(() => {
  function init(root=document) {
    root.querySelectorAll('[data-jd-question-hero]').forEach(hero=>{
      if(hero.dataset.ready)return;
      hero.dataset.ready='true';
      const controller=new AbortController(),options={signal:controller.signal};
      const video=hero.querySelector('video'),button=hero.querySelector('[data-video-toggle]');
      const small=matchMedia('(max-width:760px)'),motion=matchMedia('(prefers-reduced-motion:reduce)');
      let visible=false,userPaused=false,userRequested=false;
      const updateLabel=()=>{if(!button)return;button.textContent=video.paused?'Video afspelen':'Video pauzeren';button.setAttribute('aria-label',button.textContent);};
      function sync(){
        if(!visible||document.hidden||userPaused||(motion.matches&&!userRequested)){video.pause();updateLabel();return;}
        if(!video.getAttribute('src')){video.src=small.matches?video.dataset.mobile:video.dataset.desktop;video.load();}
        video.play().then(updateLabel).catch(updateLabel);
      }
      function select(){video.pause();video.removeAttribute('src');video.poster=small.matches?video.dataset.posterMobile:video.dataset.posterDesktop;video.load();sync();}
      button?.addEventListener('click',()=>{if(!video.paused){userPaused=true;video.pause();}else{userPaused=false;userRequested=true;sync();}updateLabel();});
      video.addEventListener('play',updateLabel);video.addEventListener('pause',updateLabel);
      const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;sync();},{threshold:.1});observer.observe(hero);
      small.addEventListener('change',select,options);motion.addEventListener('change',()=>{userRequested=false;sync();},options);
      document.addEventListener('visibilitychange',sync,options);
      document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(hero)){video.pause();observer.disconnect();controller.abort();}},options);
      select();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(),{once:true});else init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
